/** Measure rendered text width for underline segments (canvas when available). */
let measureCanvas;

export function measureTextLineWidth(line, typography, fontSize) {
  const text = String(line ?? '');
  if (!text.trim()) return 0;

  const fs = fontSize || 12;
  const ty = typography || {};

  if (typeof document !== 'undefined') {
    if (!measureCanvas) measureCanvas = document.createElement('canvas');
    const ctx = measureCanvas.getContext('2d');
    if (ctx) {
      const italic = ty.fontStyle === 'italic' ? 'italic' : 'normal';
      const w = ty.fontWeight;
      const bold =
        w === 'bold' ||
        w === '700' ||
        w === '600' ||
        w === 700 ||
        w === 600 ||
        (Number(w) >= 600 && Number.isFinite(Number(w)));
      const weight = bold ? 'bold' : 'normal';
      ctx.font = `${italic} ${weight} ${fs}px ${ty.fontFamily || 'Arial'}`;
      return ctx.measureText(text).width;
    }
  }

  return Math.max(0, text.length) * fs * 0.52;
}

/** Compute underline segment coordinates for canvas/SVG text lines. */
export function computeTextUnderlineSegments(lines, typography, fontSize, lineHeightMult, pad, innerW) {
  if (!typography?.underline || !lines?.length) return [];

  const fs = fontSize || 12;
  const lh = fs * (lineHeightMult > 0 ? lineHeightMult : 1.16);
  const align = typography.textAlign || 'left';
  const stroke = typography.fill || '#111827';
  const sw = Math.max(0.75, fs / 14);

  const segments = [];
  lines.forEach((line, i) => {
    const w = Math.min(innerW, measureTextLineWidth(line, typography, fs));
    if (w <= 0) return;

    const y = pad + fs * 0.92 + i * lh;
    let x1 = pad;
    if (align === 'center') x1 = pad + (innerW - w) / 2;
    else if (align === 'right') x1 = pad + innerW - w;

    segments.push({ x1, y, x2: x1 + w, y2: y, stroke, sw, key: i });
  });

  return segments;
}
